const axios = require("axios");

/* NodeJS */
const url = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;
const urlV5 = url.replace("v1", "v5");

module.exports = {
  createAdditionalGuest: (accessToken, propertyUid, data) =>
    axios({
      method: "POST",
      url: `${urlV5}/reservations/create_additional_guest?access_token=${accessToken}&property_uid=${propertyUid}&show_guest_details=true`,
      data,
    }),
  modifyAdditionalGuest: (accessToken, propertyUid, data) =>
    axios({
      method: "PUT",
      url: `${urlV5}/reservations/modify_guest_details?access_token=${accessToken}&property_uid=${propertyUid}&show_guest_details=true`,
      data,
    }),
  removeAdditionalGuest: (accessToken, propertyUid, reservationId, guestIds) =>
    axios({
      method: "DELETE",
      url: `${urlV5}/reservations/remove_additional_guest?access_token=${accessToken}&property_uid=${propertyUid}&reservation_id=${reservationId}&${arrayToQueryString(
        guestIds,
        "guest_ids"
      )}`,
    }),
  updateLicensePlate: (
    accessToken,
    propertyUid,
    reservationId,
    licensePlate,
    guestId,
    language,
    user
  ) =>
    axios({
      method: "POST",
      url: `${urlV5}/reservations/update_license_plate?access_token=${accessToken}&property_uid=${propertyUid}`,
      data: {
        reservation: {
          id: reservationId,
          license_plate: licensePlate,
          guest_id: guestId,
        },
        locale: language,
        user,
      },
    }),

  getUpdateLicensePlateStatus: (accessToken, jobId, guestId) =>
    axios({
      method: "GET",
      url: `${urlV5}/reservations/update_license_plate_status?job_id=${jobId}&access_token=${accessToken}&guest_id=${guestId}`,
    }),

  getReservation: (uid, lastName, roomNumber, language, accessToken) =>
    axios({
      method: "GET",
      url: `${url}/reservations`,
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        uid,
        language,
        last_name: lastName,
        room_number: roomNumber,
        access_token: accessToken,
      },
    }),
};

function arrayToQueryString(array, key) {
  if (!Array.isArray(array) || array.length === 0) {
    return "";
  }

  const queryString = array
    .map((value) => `${key}[]=${encodeURIComponent(value)}`)
    .join("&");
  return `${queryString}`;
}
